/* eslint-disable indent */
export function errorMessageFormatter(err: any): string {
  if (typeof err === 'string') {
    return err;
  }

  const status: any = {
    '-1': 'Servidor não encontrado',
    400: 'Dados inválidos',
    401: 'Sem permissão de acesso',
    403: 'Sem permissão de acesso',
    422: 'Dados inválidos',
    423: 'Acesso expirado'
  };

  switch ((err || {}).message) {
  case 'parent-entity-not-found':
    return 'Módulo "Projetos/lojas" não encontrado para salvar esta Loja';
  case 'no-internet':
  case 'NETWORK_ERROR':
    return 'Sem conexão com a internet';
  case 'api-error':
    if (err.status === -1) return 'Não conseguimos nos comunicar com o servidor';
    return status[err.status] || 'Algo deu errado...';
  default:
    return status[err.status] || 'Algo deu errado...';
  }
}